export default __webpack_public_path__ + "static/media/mark.61888200.png";